import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { queryStringChanged } from "../features/tasks/tasksSlice";

export default function Navbar() {
  const { queryString } = useSelector(state => state.tasksFilter)
  const dispatch = useDispatch()
  const inputChangeHandler = e=>{
    dispatch(queryStringChanged(e.target.value))
  }

  

  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <Link to="/">
          <img src="/images/logo.svg" />
        </Link>
        <div className="flex-1 max-w-xs search-field group">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input value={queryString} onChange={inputChangeHandler} style={{ color: '#000' }} type="text" placeholder="Search Task" className="search-input" id="lws-searchTask" />
        </div>
      </div>
    </nav>
  )
}